import { createContext, Dispatch, SetStateAction } from 'react';
import { EmailStatus, IInboxEmailSearchVars } from './types';

export const INITIAL_CALL_OFFS_SEARCH: IInboxEmailSearchVars = {
  size: 10,
  from: 0,
  statuses: [EmailStatus.UNHANDLED]
};

export const SearchCallOffsContext = createContext<IInboxEmailSearchVars>(INITIAL_CALL_OFFS_SEARCH);
SearchCallOffsContext.displayName = 'SearchCallOffsContext';

export const UpdateSearchCallOffsContext = createContext<Dispatch<SetStateAction<IInboxEmailSearchVars>> | null>(null);
UpdateSearchCallOffsContext.displayName = 'UpdateSearchCallOffsContext';
